var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgRandom = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 24,
    viewBox: "0 0 32 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#4B4B4F",
    strokeLinecap: "round",
    strokeWidth: 3,
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.072 17.348c1.145 1.33 2.64 2.388 4.42 2.995 5.329 1.817 11.12-1.028 12.938-6.356.608-1.782.684-3.61.33-5.329M22.427 3.963c-1.136-1.292-2.608-2.319-4.353-2.915C12.746-.769 6.953 2.076 5.136 7.404c-.595 1.746-.682 3.538-.353 5.228",
    transform: "translate(1 1)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M20.148 12.925L24.607 8.466 29.066 12.925M9.418 8.466L4.96 12.925.5 8.466",
    transform: "translate(1 1)"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRandom, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/random.072cb702.svg";
export { ForwardRef as ReactComponent };